import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from "@angular/core";
import { UpdateMultiFactorAuthComponent } from "./update-multi-factor-auth.component";


class UpdateMultiFactorAuthSession implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    resolver: ComponentFactoryResolver;
    viewContainerRef: ViewContainerRef;
    updateMultiFactorAuthComponentRef: ComponentRef<UpdateMultiFactorAuthComponent>;

    constructor(formId: string, payload: object) {
        console.log('Inside Profile Update Multi-factor AuthTs form constructor');
        this.formId = formId;
        this.payload = payload;
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
        console.log('Profile Update Multi-factor AuthTs Ts session started: ' + this.formId);
        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.resolver = (clientContext as any).resolver;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {
        console.log('Profile Update Multi-factor AuthTs session ended: ' + this.formId);
      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        console.log('Profile Update Multi-factor AuthTs session Input: ' + this.formId);
        const self = this;
        self.viewContainerRef.clear();
        const factory: ComponentFactory<UpdateMultiFactorAuthComponent> =
        self.resolver.resolveComponentFactory(UpdateMultiFactorAuthComponent);
        self.updateMultiFactorAuthComponentRef = self.viewContainerRef.createComponent(factory);

        self.updateMultiFactorAuthComponentRef.instance.onMFAProfileSubmit = self.onMFAProfileUpdateSubmit.bind(self);

        this.updateMultiFactorAuthComponentRef.instance.emailStatus = this.clientContext['MFAEmailStatus'];
        this.updateMultiFactorAuthComponentRef.instance.numberStatus = this.clientContext['MFAMobileStatus'];

        this.updateMultiFactorAuthComponentRef.instance.email = this.clientContext['email_mfa'];
        this.updateMultiFactorAuthComponentRef.instance.number = this.clientContext['mobile_mfa'];

        console.log('Profile Update Multi-factor AuthTs constructor payload:', this.payload);

        const journeyPayload = this.payload as JourneyPayload;
        console.log('Profile Update Multi-factor AuthTs payload actions using interface', journeyPayload.actions);


        return new Promise((resolve, reject) => {
          self.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
              console.log('Profile Update Multi-factor AuthTs createFormInputSubmissionRequest SUCCESS payload: ', payload);
              self.submitBlock = null;
            } catch (e) {
              console.log('Profile Update Multi-factor AuthTs createFormInputSubmissionRequest ERROR payload: ', payload);
              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {
        console.log('Profile Update Multi-factor AuthTs onContinue for ' + this.formId + ' payload:', payload);
      }

      onError(payload: object): void {
        console.log('Profile Update Multi-factor AuthTs onError for ' + this.formId + ' payload:', payload);
      }

      private onMFAProfileUpdateSubmit(payload: object) {
        const data = payload;
        this.submitBlock(data);
      }
}

interface JourneyPayload {
    actions: ActionsInPayload[];
    stat: string;
    code: string;
    flow: string;
  }

interface ActionsInPayload {
    [key: string]: any;
  }

export default UpdateMultiFactorAuthSession;
